import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
import { Button } from 'react-bootstrap';
import { Collapse } from 'components/Transition';

interface INavState {
    showNavMenu: boolean;
}

const mediaQueryOfScreen = typeof window === 'undefined' || window.matchMedia('(max-width: 768px)');

class Nav extends Component<{}, INavState> {
    readonly state = {
        showNavMenu: !(mediaQueryOfScreen as MediaQueryList).matches
    } as INavState;

    componentDidMount() {
        document.addEventListener('click', this.hideNavMenu, false);
        (mediaQueryOfScreen as MediaQueryList).addListener(this.switchScreen);
    }

    componentWillUnmount() {
        document.removeEventListener('click', this.hideNavMenu, false);
        (mediaQueryOfScreen as MediaQueryList).removeListener(this.switchScreen);
    }

    // 隐藏侧边栏
    hideNavMenu = (event: MouseEvent) => {
        if ((mediaQueryOfScreen as MediaQueryList).matches && this.state.showNavMenu) {
            this.toggleNavMenu(false);
        }
    };

    // 控制侧边栏的显隐
    toggleNavMenu = (status?: boolean) => {
        const showNavMenu = typeof status === 'boolean' ? status : !this.state.showNavMenu;

        this.setState({ showNavMenu });
    };

    // 根据屏幕的切换控制侧边栏的显隐
    switchScreen = mediaQuery => {
        this.toggleNavMenu(!mediaQuery.matches);
    };

    render() {
        const { showNavMenu } = this.state;

        return (
            <div className="pricing-nav-root">
                <Collapse in={showNavMenu} direction="h">
                    <nav className="pricing-nav">
                        <NavLink to="/pricing/commissions-us">Commission(US)</NavLink>
                        <NavLink to="/pricing/commissions-hk">Commission(HK)</NavLink>
                        <NavLink to="/pricing/interest">Interest</NavLink>
                    </nav>
                </Collapse>
                <div className="menu-switch">
                    <Button
                        className="switch-btn"
                        onClick={ev => {
                            this.toggleNavMenu();
                            ev.nativeEvent.stopImmediatePropagation();
                        }}>
                        <span className="icon">icon</span>
                        SHOW SIDE NAVIGATION
                    </Button>
                </div>
            </div>
        );
    }
}

export default Nav;
